import React, { RefObject, useState } from 'react'
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import FA from 'react-fontawesome'
import ContextLoading from '../Loading'

import { Container, Header, Nav } from './styles'
import logo from './logo.png'
import { scrollToRef } from '../../services/scroll'
import Contact from '../Contact'

interface Props {
  refs?: Record<string, RefObject<HTMLElement>>
  isContactOpen?: boolean
  setIsContactOpen?: (isContactOpen: boolean) => void
}
export default function ({ refs, isContactOpen, setIsContactOpen }: Props) {
  const { t, ready } = useTranslation(['components/header'])
  const [isNavOpen, setIsNavOpen] = useState(false)

  return (
    <ContextLoading isLoading={!ready}>
      <div>
        <Contact isOpen={isContactOpen} setIsOpen={setIsContactOpen} />
        <Container isFixed={false} isNavOpen={isNavOpen}>
          <Header isNavOpen={isNavOpen}>
            <Link to="/">
              <img src={logo} alt="R2U" />
            </Link>
            <button onClick={() => setIsNavOpen(!isNavOpen)} type="button">
              <FA size="2x" name="bars" />
            </button>
            <Nav isOpen={isNavOpen}>
              <button onClick={() => setIsNavOpen(!isNavOpen)} type="button">
                <FA size="2x" name="times" />
              </button>
              <ul>
                <li>
                  <Link
                    onClick={() => {
                      if (refs) {
                        scrollToRef(refs.productsRef)
                        setIsNavOpen(false)
                      }
                    }}
                    to="/"
                  >
                    {t('our-products')}
                  </Link>
                </li>
                <li>
                  <Link to="/mobly">{t('case-mobly')}</Link>
                </li>
                <li>
                  <button
                    onClick={() => {
                      setIsContactOpen(true)
                      setIsNavOpen(false)
                    }}
                    type="submit"
                  >
                    {t('contact')}
                  </button>
                </li>
                <li>
                  <a href="https://console.r2u.io">{t('login')}</a>
                </li>
              </ul>
            </Nav>
          </Header>
          <hr />
        </Container>
        <Container isFixed isNavOpen={!isNavOpen}>
          <Header isNavOpen={!isNavOpen}>
            <Link to="/">
              <img src={logo} alt="R2U" />
            </Link>
          </Header>
          <hr />
        </Container>
      </div>
    </ContextLoading>
  )
}
